import { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Checkbox } from "primereact/checkbox";
import axios from "axios";
import { Card } from 'primereact/card';
const apiUrl = process.env.REACT_APP_API_URL;

export function ListCat() {
  const [categories, setCategories] = useState([]);
  const toast = useRef(null);

  useEffect(() => {
    fetch(`${apiUrl}IHM/api/zotCategorie.php`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setCategories(data.categories);
        }
      })
      .catch((err) => console.error(err));
  }, []);

  const onRowReorder = async (e) => {
    const newOrder = e.value.map((item, index) => ({
      idtally: item.idtally,
      ordre: index + 1,
    }));

    setCategories(e.value);

    try {
      await axios.post(`${apiUrl}IHM/api/updateCategorieOrder.php`, {
        order: newOrder,
      });

      window.location.reload();
      // toast.current.show({
      //   severity: "success",
      //   summary: "Ordre sauvegardé",
      //   detail: "Le nouvel ordre a été enregistré.",
      //   life: 3000,
      // });
    } catch (error) {
      // toast.current.show({
      //   severity: "error",
      //   summary: "Erreur",
      //   detail: "Impossible d’enregistrer l’ordre",
      //   life: 3000,
      // });
    }
  };

  const toggleAfficher = async (rowData, value) => {
    const updatedCats = categories.map((cat) =>
      cat.idtally === rowData.idtally
        ? { ...cat, afficher_admin: value ? 1 : 0 }
        : cat
    );
    setCategories(updatedCats);

    try {
      await axios.post(`${apiUrl}IHM/api/updateCategorieAfficher.php`, {
        idtally: rowData.idtally,
        afficher_admin: value ? 1 : 0,
      });

      window.location.reload();
      // toast.current.show({
      //   severity: "success",
      //   summary: "Mise à jour",
      //   detail: `Catégorie ${value ? "affichée" : "masquée"}.`,
      //   life: 2000,
      // });
    } catch (error) {
      // toast.current.show({
      //   severity: "error",
      //   summary: "Erreur",
      //   detail: "Impossible de mettre à jour l'affichage",
      //   life: 3000,
      // });
    }
  };



   const toggleVueGlobale = async (rowData, value) => {
    const updatedCats = categories.map((cat) =>
      cat.idtally === rowData.idtally
        ? { ...cat, vue_globale: value ? 1 : 0 }
        : cat
    );
    setCategories(updatedCats);

    try {
      await axios.post(`${apiUrl}IHM/api/updateVueGlobale.php`, {
        idtally: rowData.idtally,
        vue_globale: value ? 1 : 0,
      });

      window.location.reload();
      // toast.current.show({
      //   severity: "success",
      //   summary: "Mise à jour",
      //   detail: `Vue globale ${value ? "affichée" : "masquée"}.`,
      //   life: 2000,
      // });
    } catch (error) {
      // toast.current.show({
      //   severity: "error",
      //   summary: "Erreur",
      //   detail: "Impossible de mettre à jour l'affichage",
      //   life: 3000,
      // });
    }
  };

  const header = (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <h3>Catégories</h3>
    </div>
  );
  if (
    localStorage.getItem("us") === "admin" ||
    localStorage.getItem("us") === "dev"
  ) {
    return (
      <>
        <DataTable
          value={categories}
          rows={25}
          size="small"
          header={header}
          dataKey="idtally"
          paginator
          reorderableRows
          onRowReorder={onRowReorder}
          tableStyle={{ minWidth: "50rem" }}
          rowsPerPageOptions={[5, 8, 10, 25, 50]}
          scrollable
          scrollDirection="horizontal"
          paginatorTemplate={
            "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
          }
          emptyMessage="Aucune catégorie pour le moment"
          paginatorRight={
            <span style={{ margin: "10px", fontWeight: "bold" }}>
              Résultats : {categories.length}
            </span>
          }
        >
          <Column rowReorder headerStyle={{ width: "3rem" }} />
          <Column field="idtally" header="ID" />
          <Column field="title" header="Catégorie" style={{ width: "30%" }} />
          <Column field="url" header="URL" />
          <Column field="nb" header="Projets" />

          
          <Column
            field="afficher_admin"
            header="Afficher"
            style={{ textAlign: "center", width: "120px" }}
            body={(rowData) => (
              <Checkbox
                checked={rowData.afficher_admin == 1}
                onChange={(e) => toggleAfficher(rowData, e.checked)}
              />
            )}
          />
          <Column
            field="vue_globale"
            header="Vue globale"
            style={{ textAlign: "center", width: "120px" }}
            body={(rowData) => (
              <Checkbox
                checked={rowData.vue_globale == 1}
                onChange={(e) => toggleVueGlobale(rowData, e.checked)}
              />
            )}
          />
        </DataTable>
      </>
    );
  } else {
    return (
      <div
        className="p-d-flex p-jc-center p-ai-center"
        style={{ height: "100vh" }}
      >
        <Card title="Page Non Disponible" className="p-shadow-3">
          <div className="p-text-center">
            <p>
              Nous sommes désolés, mais la page que vous cherchez n'est pas
              disponible.
            </p>
          </div>
        </Card>
      </div>
    );
  }
}
